import React from 'react';
import './addRemove.style.sass';
import {Icon} from "rsuite";
import {createStructuredSelector} from "reselect";
import {selectProduct} from "../../redux/users/users.selector";
import {connect} from 'react-redux';
import {AddProduct, ClearProduct, removeProduct} from "../../redux/users/users.actions";
import {selectInstallation, selectInternalOrExternal} from "../../redux/cart/cart.selector";

const AddRemoveComponent = ({productItem,AddProduct, Clear, Remove , item, productPage, getInstall, getInteOrEX}) => {
    if(productPage){
        item.install = getInstall;
        item.productFor = getInteOrEX;
    }
    let selectedProduct = productItem.find(z => z.id === item.id);
    return (
        <div className='add-remove-area' style={productPage ? null: {justifyContent: 'flex-end'}}>
            <div className='action-area' style={productPage ? {borderRadius:'20px'}:{borderRadius:'0 20px 20px 0'}}>
                <Icon onClick={()=>AddProduct(item)} icon="data-increase" />
                <span>
                    {productItem.find(o=> o.id === item.id).quantity}
                </span>
                {
                    productItem.find(o=> o.id === item.id).quantity === 1 ?
                        (<Icon onClick={()=>Clear(item)} icon='trash2' />) :
                        (<Icon onClick={()=>Remove(selectedProduct)} icon="data-decrease" />)
                }
            </div>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    productItem: selectProduct,
    getInstall: selectInstallation,
    getInteOrEX : selectInternalOrExternal
});
const mapDispatchToProps = dispatch => ({
    Clear: item => dispatch(ClearProduct(item)),
    Remove: item => dispatch(removeProduct(item)),
    AddProduct: item => dispatch(AddProduct(item))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddRemoveComponent);